import React from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { AsyncPaginate } from "react-select-async-paginate";
import { lookupSelector } from "../../redux/lookupSlice";
import { setSurvey, surveySelector } from "../../redux/surveySlice";
import { surveyorSelector } from "../../redux/userSlice";
import Select from "../Form/Select";
import Selectable from "../Form/Selectable";

function AdminInputs({ field }) {
  const dispatch = useDispatch();
  const survey = useSelector(surveySelector);
  const lookup = useSelector(lookupSelector);
  const surveyors = useSelector(surveyorSelector);

  const handleChange = (e) => {
    if (field.name === "clientName") {
      dispatch(setSurvey({ field: "clientRef", value: String(e?.clientRef) }));
      dispatch(setSurvey({ field: "clientName", value: e?.name }));
      return;
    }
  };

  return (
    <div className="fieldset mb-4">
      <Form.Group>
        <Form.Label>{field.title}</Form.Label>
        {(field.type === "text" || field.type === "number") && (
          <Form.Control
            value={survey[field.name]}
            type={field.type}
            onChange={(e) => field.handleChange(e.target.value)}
            placeholder={field.title}
          />
        )}

        {field.type === "select" &&
          (field.title === "Client" ? (
            <AsyncPaginate
              debounceTimeout={500}
              placeholder={field.title}
              defaultValue
              getOptionLabel={(e) =>
                field.name === "surveyorId"
                  ? e.firstName + " " + e.lastName
                  : `${e.clientRef} | ${e.name}`
              }
              getOptionValue={(e) => e.id}
              isClearable={true}
              value={
                survey["clientRef"]
                  ? {
                      id: survey["clientRef"],
                      clientRef: survey["clientRef"],
                      name: survey["clientName"],
                    }
                  : ""
              }
              onInputChange={(e) => field.handleInputChange(e)}
              loadOptions={() => field.fetchData()}
              onChange={(e) => handleChange(e)}
            />
          ) : field.name === "surveyorId" ? (
            <Select
              options={surveyors.data}
              value={{
                id: survey["surveyorId"] || "",
                firstName: survey["surveyorName"]?.split(" ")[0] || "",
                lastName: survey["surveyorName"]?.split(" ")[1] || "",
              }}
              onChange={(e) => field.handleChange(e)}
              placeholder={field.title}
            />
          ) : (
            <Selectable
              options={
                field.name === "surveyorId"
                  ? surveyors.data
                  : lookup[field.name]
              }
              value={survey[field.name]}
              onChange={(e) => field.handleChange(e)}
              placeholder="Choose Value"
            />
          ))}
        {field.type === "textarea" && (
          <textarea
            name={field.name}
            placeholder={field.title}
            value={survey[field.name]}
            required
            onChange={(e) => field.handleChange(e.target.value)}
            id=""
            cols="30"
            rows="5"
            className="form-control"
          ></textarea>
        )}
      </Form.Group>
    </div>
  );
}

export default AdminInputs;
